<template>
  <div class="contact page">
    <p class="p">
      If you have any questions please feel free to contact us at
      <a href="mailto:thebardailongs@gmail.com">
        thebardailongs@gmail.com
      </a>
      or
      <a href="mailto:wedding@thebardailongs.com">
        wedding@thebardailongs.com
      </a>
    </p>
    <p class="p">
      3586 Charles Street,<br />
      San Diego, California, 92106.<br />
      United States of America
    </p>
    <p class="p">
      244 TARACOVE PLACE NE<br />
      CALGARY AB T3J 4T4<br />
      Canada
    </p>
    <p class="p">
      Flat 3<br />
      40 Sackville Gardens<br />
      Hove East Sussex BN3 4GH<br />
      United Kingdom
    </p>
  </div>
</template>

<script>
export default {
  name: "Contact"
};
</script>

<style lang="scss">
.contact {
  display: flex;
  flex-direction: column;
}
</style>
